import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ChangeDetectionStrategy,
} from '@angular/core';
import {
    ResourceOptionalField,
    ResourceOptionalSection,
} from '@masar/common/models';

@Component({
    selector: 'app-resource-optional-setting-row',
    templateUrl: './resource-optional-setting-row.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    styles: [
        `
            :host {
                display: contents;
            }
        `,
    ],
})
export class ResourceOptionalSettingRowComponent implements OnChanges {
    @Input() public item: ResourceOptionalField | ResourceOptionalSection;

    /** When false, the Required? toggle is not shown. */
    @Input() public showRequired = true;

    /**
     * When Required? is hidden, still occupy its grid cell so cols-3 layouts
     * stay aligned. Set false for cols-2 layouts (e.g. operation sections).
     */
    @Input() public keepRequiredSlot = true;

    /** When true, Required? stays disabled even if Enabled? is on. */
    @Input() public isRequiredAlwaysDisabled = false;

    /** Accent border on the name cell. Operation sections use blue. */
    @Input() public nameBorderClass: 'border-green-500' | 'border-blue-500' =
        'border-green-500';

    public get isRequiredToggleDisabled(): boolean {
        return !this.item?.isEnabled || this.isRequiredAlwaysDisabled;
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['item'] && this.item && !this.item.isEnabled) {
            this.item.isRequired = false;
        }
    }

    public onEnabledChange(_isEnabled: boolean): void {
        // AC2: turning Enabled off clears Required.
        // AC3: turning Enabled on starts with Required off.
        this.item.isRequired = false;
    }
}
